import { ALTERAR_REGISTROS_POR_PAGINA_ITINERARIO_EMBARQUE } from '../types'

export default function alterarRegistrosPorPaginaItinerarioEmbarque (valor) {
  return {
    type: ALTERAR_REGISTROS_POR_PAGINA_ITINERARIO_EMBARQUE,
    payload: valor
  }
}